import type { TFunction } from 'i18next'
import type { ClosingPackageManifest } from '@/hooks/useClosingPackage'
import { formatDate, type DateFormatOptions } from '@/lib/date'

/** Shared wording for the on-screen checklist and the downloaded manifest. */
export function closingPackageCoverageWarning(
  manifest: ClosingPackageManifest,
  t: TFunction<'common'>,
  dateOptions: DateFormatOptions,
): string | null {
  if (manifest.bank_statement_coverage === 'none') return t('closing_package.bank_coverage_none')
  if (manifest.bank_statement_coverage === 'partial') {
    return t('closing_package.bank_coverage_partial', {
      date: formatDate(manifest.bank_statement_covered_through, dateOptions),
    })
  }
  return null
}
